import defaultConfig, { type Config } from './default';
import localConfig from './local';
import preprodConfig from './preprod';
import productionConfig from './production';
import qaConfig from './qa';
import { determineCurrentEnvironment } from './services';

/** Determines which config to load based on the current host environment */
function getConfig(): Config {
  const environment = determineCurrentEnvironment();

  switch (environment) {
    case 'local':
    case 'smrx-dev': {
      // Local and dev point to smrx-dev API
      return {
        ...defaultConfig,
        ...localConfig,
        descope: {
          ...defaultConfig.descope,
          ...localConfig.descope,
          pharmacyPortal: {
            ...defaultConfig.descope.pharmacyPortal,
            ...localConfig.descope?.pharmacyPortal,
          },
        },
        services: {
          ...defaultConfig.services,
          ...localConfig.services,
        },
        statsig: {
          ...defaultConfig.statsig,
          ...localConfig.statsig,
        },
      };
    }

    case 'smrx-qa': {
      return {
        ...defaultConfig,
        ...qaConfig,
        descope: {
          ...defaultConfig.descope,
          ...qaConfig.descope,
          pharmacyPortal: {
            ...defaultConfig.descope.pharmacyPortal,
            ...qaConfig.descope?.pharmacyPortal,
          },
        },
        statsig: {
          ...defaultConfig.statsig,
          ...qaConfig.statsig,
        },
      };
    }

    case 'smrx-preprod': {
      return {
        ...defaultConfig,
        ...preprodConfig,
        descope: {
          ...defaultConfig.descope,
          ...preprodConfig.descope,
          pharmacyPortal: {
            ...defaultConfig.descope.pharmacyPortal,
            ...preprodConfig.descope?.pharmacyPortal,
          },
        },
        statsig: {
          ...defaultConfig.statsig,
          ...preprodConfig.statsig,
        },
      };
    }

    case 'production': {
      return {
        ...defaultConfig,
        ...productionConfig,
        descope: {
          ...defaultConfig.descope,
          ...productionConfig.descope,
          pharmacyPortal: {
            ...defaultConfig.descope.pharmacyPortal,
            ...productionConfig.descope?.pharmacyPortal,
          },
        },
        statsig: {
          ...defaultConfig.statsig,
          ...productionConfig.statsig,
        },
      };
    }

    default: {
      return defaultConfig;
    }
  }
}

export const config = getConfig();

const apiServiceBaseUrl = config?.services?.api;
export const graphqlApiUrl = `${apiServiceBaseUrl}/query`;
